// Dependencies
import { Component } from 'react';
import { connect } from 'react-redux';

import CheckBox from 'components/atoms/CheckBox';
import SearchGroup from 'components/atoms/SearchGroup';
import { SetSearchObjectAction } from 'store/actions/layoutActions';
import { RootState, TagType } from 'types';
import { DefaultData, FilterObjectType } from 'types/search';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface TransitTagRouteFiltersComponentProps {
    tags: TagType[];
    defaultData: DefaultData;
    setFilterObject: SetSearchObjectAction;
    filterObject: FilterObjectType;
}

interface TransitTagRouteFiltersComponentState {
    tags: TagType[];
    filterObject: FilterObjectType;
}

class TransitTagRouteFilters extends Component<
    TransitTagRouteFiltersComponentProps,
    TransitTagRouteFiltersComponentState
> {
    constructor(props: TransitTagRouteFiltersComponentProps) {
        super(props);
        this.state = {
            tags: props.tags,
            filterObject: props.filterObject,
        };
    }

    static getDerivedStateFromProps(
        props: TransitTagRouteFiltersComponentProps,
        state: TransitTagRouteFiltersComponentState
    ) {
        if (checkDifferent(props.tags, state.tags) || checkDifferent(props.filterObject, state.filterObject)) {
            return { tags: props.tags, filterObject: props.filterObject };
        }
        return null;
    }

    handleChange = (value: number) => {
        const { filterObject } = this.state;
        const tags = [...filterObject.tags];

        const updatedTags = tags.includes(value)
            ? tags.filter((tag) => tag !== value) // Remove the value
            : [...tags, value]; // Add the value

        const updatedFilterObject = { ...filterObject, tags: updatedTags };

        this.props.setFilterObject(updatedFilterObject);
    };

    render() {
        return (
            <SearchGroup open title={translate('Transit')}>
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-x-1  ">
                        {this.state.tags
                            ?.filter((tag: TagType) => {
                                const defTag = this.props.defaultData.tags.find((x) => {
                                    return x.tag_id === tag.id;
                                });
                                if (!defTag) {
                                    return tag.type === 'positioning' && tag.status == 'active';
                                }

                                return tag.type === 'positioning' && defTag.total >= 1;
                            })
                            .filter((tag: TagType) => {
                                return (
                                    this.props.defaultData.tags.map((x) => x.tag_id).includes(tag.id) ||
                                    this.props.defaultData.tags.map((x) => x.slug).includes(tag.key)
                                );
                            }).sort(function (a, b) {
                                if (a.tag > b.tag) return 1;
                                if (a.tag < b.tag) return -1;
                                return 0;
                            })
                            .sort(function (a, b) {
                                if (a.order > b.order) return 1;
                                if (a.order < b.order) return -1;
                                return 0;
                            })
                            .map((tag: TagType) => {
                                return (
                                    <div key={tag.id} className="flex gap-1 cursor-pointer">
                                        <div>
                                            <CheckBox
                                                name={tag.tag}
                                                onChange={() => {
                                                    this.handleChange(tag.id);
                                                }}
                                                value={this.state.filterObject?.tags.includes(tag.id)}
                                            ></CheckBox>
                                        </div>
                                        <div
                                            onClick={() => {
                                                this.handleChange(tag.id);
                                            }}
                                            className="capitalize truncate"
                                        >
                                            {tag.label}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </SearchGroup>
        );
    }
}

const transittagroutefiltersStateToProps = (state: RootState) => ({
    tags: state.port.tags,
    defaultData: state.port.defaultData,
});

const transittagroutefiltersDispatchToProps = () => ({});

export default connect(
    transittagroutefiltersStateToProps,
    transittagroutefiltersDispatchToProps
)(TransitTagRouteFilters);
